<template>

  <v-navigation-drawer v-model="drawer" app color="blue-grey" dark>
      <v-list dense>
        
        <!-- user profile -->
        <v-list-item two-line link>
            <v-list-item-avatar><img :src="require('../assets/cool.jpeg')"></v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="text-capitalize">{{ $store.state.user.username }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.user.admin ? 'Role: Admin' : 'Role: Editor'}}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-divider />

        <!-- Dashboard -->
        <v-list-item link :to="'/admin'" exact>
          <v-list-item-action><v-icon>mdi-home</v-icon></v-list-item-action>
          <v-list-item-content><v-list-item-title>Dashboard</v-list-item-title></v-list-item-content>
        </v-list-item>

        <!-- users management -->
        <v-list-item v-if="$store.state.user.admin" link :to="'/admin/users'" exact>
          <v-list-item-action><v-icon>mdi-account</v-icon></v-list-item-action>
          <v-list-item-content><v-list-item-title>Manage Users</v-list-item-title></v-list-item-content>
        </v-list-item>

        <div class="grey--text pl-5 pt-5">Accounts</div>

        <!-- all accounts -->
        <v-list-item link v-for="list in lists" :key="list.name" :to="list.route" exact>
          <v-list-item-action><v-icon>{{ list.icon }}</v-icon></v-list-item-action>
          <v-list-item-content><v-list-item-title>{{ list.name }}</v-list-item-title></v-list-item-content>
        </v-list-item>

        <div class="pt-3"></div>
        
        <!-- settings -->
        <v-list-item link :to="'/admin/settings'">
          <v-list-item-action><v-icon>mdi-link</v-icon></v-list-item-action>
          <v-list-item-content><v-list-item-title>Settings</v-list-item-title></v-list-item-content>
        </v-list-item>

      </v-list>

        <template v-slot:append>
            <div class="pa-2"><v-btn block link @click="logout">Logout</v-btn></div>
        </template>

    </v-navigation-drawer>

</template>

<script>
export default {

    props: [ 'drawer' ],

    data() {
        return {
            lists: [
                { name: 'E-Mail', icon: 'mdi-email', route: '/admin/accounts/email' },
                { name: 'Facebook', icon: 'mdi-facebook', route: '/admin/accounts/facebook' },
                { name: 'Godaddy', icon: 'mdi-earth', route: '/admin/accounts/godaddy' },
                { name: 'PayPal', icon: 'mdi-alpha-p-box', route: '/admin/accounts/paypal' },
                { name: 'Virtual Cards', icon: 'mdi-credit-card-settings-outline', route: '/admin/accounts/virtualcard' },
                { name: 'Websites', icon: 'mdi-web', route: '/admin/accounts/website' },
                { name: 'Apple', icon: 'mdi-apple', route: '/admin/accounts/apple' },
            ],

            isLoading: false
        }
    },

    methods: {

       logout() {
         this.isLoading = true
         this.$store.dispatch('userSignOut')
       },

    }

}
</script>
